const registerValidators = {};

export default registerValidators;
